import { render, staticRenderFns } from "./DmqCartRetailerSummary.vue?vue&type=template&id=2fc4730f&"
import script from "./DmqCartRetailerSummary.vue?vue&type=script&lang=ts&"
export * from "./DmqCartRetailerSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports